export const messages = {
  en: {
    initializeCommunityManage: {
      search: {
        title: 'Search Conditions',
        communityId: 'Please enter community ID',
        name: 'Please enter community name'
      },
      list: {
        title: 'Initialize Community Data'
      },
      table: {
        communityId: 'Community ID',
        name: 'Community Name',
        nearbyLandmarks: 'Nearby Landmarks',
        cityCode: 'City Code',
        state: 'Status'
      },
      button: {
        initialize: 'Initialize'
      },
      initializeSuccess: 'Initialize successfully',
      fetchError: 'Failed to fetch community data'
    },
    chooseinitializeCommunity: {
      dialog: {
        title: 'Warning',
        warning: 'Please operate carefully',
        communityInfo: 'This operation will clear all data of community [{name}], community ID is [{id}]. Please confirm again with relevant personnel!',
        passwordPlaceholder: 'Please enter developer password'
      },
      button: {
        cancel: 'Cancel',
        confirm: 'Confirm Initialize'
      },
      validation: {
        passwordRequired: 'Developer password is required'
      }
    }
  },
  zh: {
    initializeCommunityManage: {
      search: {
        title: '查询条件',
        communityId: '请输入小区ID',
        name: '请输入小区名称'
      },
      list: {
        title: '初始化小区数据'
      },
      table: {
        communityId: '小区ID',
        name: '小区名称',
        nearbyLandmarks: '附近地标',
        cityCode: '城市编码',
        state: '状态'
      },
      button: {
        initialize: '格式化'
      },
      initializeSuccess: '初始化成功',
      fetchError: '获取小区数据失败'
    },
    chooseinitializeCommunity: {
      dialog: {
        title: '温馨提示',
        warning: '请慎重操作',
        communityInfo: '此操作将清空所有【{name}】小区数据,小区编码为【{id}】。谨慎期间，请再次跟相关人员核实确认！',
        passwordPlaceholder: '请输入开发者密码'
      },
      button: {
        cancel: '点错了',
        confirm: '确认格式化'
      },
      validation: {
passwordRequired: '开发者密码不能为空'
      }
    }
  },
  'zh-TW': {
    initializeCommunityManage: {
      search: {
        title: '查詢條件',
        communityId: '請輸入小區ID',
        name: '請輸入小區名稱'
      },
      list: {
        title: '初始化小區數據'
      },
      table: {
        communityId: '小區ID',
        name: '小區名稱',
        nearbyLandmarks: '附近地標',
        cityCode: '城市編碼',
        state: '狀態'
      },
      button: {
        initialize: '格式化'
      },
      initializeSuccess: '初始化成功',
      fetchError: '獲取小區數據失敗'
    },
    chooseinitializeCommunity: {
      dialog: {
        title: '溫馨提示',
        warning: '請慎重操作',
        communityInfo: '此操作將清空所有【{name}】小區數據,小區編碼為【{id}】。謹慎期間，請再次跟相關人員核實確認！',
        passwordPlaceholder: '請輸入開發者密碼'
      },
      button: {
        cancel: '點錯了',
        confirm: '確認格式化'
      },
      validation: {
        passwordRequired: '開發者密碼不能為空'
      }
    }
  }
}